import { Routes } from '@angular/router';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { RoleChildGuard } from '../../guard/auth-guard/role-child.guard';
import { Role } from '../../core/enums/role.enum';

export const solicitarRecursoProfissionalRoutes: Routes = [
  {
    path: 'solicitar-recurso-profissional',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./solicitar-recurso-profissional.component').then(
            (m) => m.SolicitarRecursoProfissionalComponent,
          ),
        data: {
          title: 'Interposição de Recurso Profissional',
          roles: [Role.SOLICITAR_RECURSO_PROFISSIONAL_CONSULTAR],
          breadcrumb: [{ label: 'Solicitar Recurso Profissional', url: '/solicitar-recurso-profissional' }],
        },
      },
      {
        path: 'cadastrar',
        loadComponent: () =>
          import('./solicitar-recurso-profissional-form/solicitar-recurso-profissional-form.component').then(
            (m) => m.SolicitarRecursoProfissionalFormComponent,
          ),
        data: {
          title: 'Solicitar Interposição de Recurso Profissional',
          roles: [Role.SOLICITAR_RECURSO_PROFISSIONAL_CADASTRAR],
          breadcrumb: [
            { label: 'Solicitar Interposição de Recurso Profissional', url: '/solicitar-recurso-profissional' },
            { label: 'Cadastrar', url: '/solicitar-recurso-profissional/cadastrar' },
          ],
        },
      },
      {
        path: 'editar/:id',
        loadComponent: () =>
          import('./solicitar-recurso-profissional-form/solicitar-recurso-profissional-form.component').then(
            (m) => m.SolicitarRecursoProfissionalFormComponent,
          ),
        data: {
          title: 'Editar Interposição de Recurso Profissional',
          roles: [Role.SOLICITAR_RECURSO_PROFISSIONAL_EDITAR],
          breadcrumb: [
            { label: 'Editar Interposição de Recurso Profissional', url: '/solicitar-recurso-profissional' },
            { label: 'Editar', url: '/solicitar-recurso-profissional/editar' },
          ],
        },
      },
      {
        path: 'visualizar/:id',
        loadComponent: () =>
          import('./solicitar-recurso-profissional-form/solicitar-recurso-profissional-form.component').then(
            (m) => m.SolicitarRecursoProfissionalFormComponent,
          ),
        data: {
          title: 'Visualizar Interposição de Recurso Profissional',
          roles: [Role.SOLICITAR_RECURSO_PROFISSIONAL_VISUALIZAR],
          breadcrumb: [
            { label: 'Visualizar Interposição de Recurso Profissional', url: '/solicitar-recurso-profissional' },
            { label: 'Visualizar', url: '/solicitar-recurso-profissional/visualizar' },
          ],
        },
      },
    ],
  },
];
